import type { Panel } from '@/types/projectTypes';

/**
 * Generates the appropriate panel image URL based on the panel's color
 * @param panel - The panel model with color information
 * @returns The image URL for the panel
 */
export function getPanelImageUrl(panel: Panel): string {
  try {
    if (panel.color) {
      // Convert color to lowercase and create filename
      const colorFileName = `panel_${panel.color.toLowerCase()}.png`;
      return require(`@/assets/${colorFileName}`);
    }
  } catch (error) {
    // If color-specific image doesn't exist, fall back to default
    console.warn(`Panel image for color "${panel.color}" not found, using fallback`);
  }
  
  // Fallback to default panel image
  return require('@/assets/panel.png');
}